import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RegistrationService } from '@shared/services/registration.service';
import { APP_CONFIG, AppConfig } from '@src/app/app-config.module';

@Component({
    selector: 'direct-sales-thank-you-page',
    templateUrl: './direct-sales-thank-you-page.component.html',
    styleUrl: './direct-sales-thank-you-page.component.scss'
})

export class DirectSalesThankYouPageComponent implements OnInit {
    postRegistrationInfoUrl: string;
    companyName: string = null;
    email: string = null;
    loading = true;

    constructor(
        @Inject(APP_CONFIG) private readonly config: AppConfig,
        private readonly translateService: TranslateService,
        private readonly registrationService: RegistrationService) {
    }

    ngOnInit() {
        this.registrationService.getApplication()
            .then(application => {
                this.email = application.applicant.email;
                this.companyName = application.company.registeredName;
                this.loading = false;
            });

        this.translateService.onLangChange.subscribe(e => {
            this.handleLanguageChange(e.lang);
        });
        this.handleLanguageChange(this.translateService.currentLang);
    }

    handleLanguageChange(lang: string) {
        this.postRegistrationInfoUrl = this.config.postRegistrationInfoURLs[lang] || this.config.postRegistrationInfoURLs.fallback;
    }

    onClickCTA() {
        window.location.assign(this.postRegistrationInfoUrl);
    }
}
